import { newGuid } from "@/assets/utils/guid";
import { PolicyConfiguration, POLICY_LIMIT_TYPE, POLICY_TYPE } from "../policy-configurations";
import { SeatingStrategyBase, SEATING_STRATEGY_TYPE } from "../seating-strategies";

export class VenueTable {
  constructor(id, name, seatCount, venueTableType) {
    this.id = id ? id : newGuid();
    this.venueTableId = { id: this.id};
    this.name = name;
    this.seatCount = seatCount;
    this.venueTableType = venueTableType;
    this.created = undefined;
    this.deleted = undefined;
    this.venuePolicies = [];
    this.seatingStrategies = [];
    this.bookingOnRequestOnly = false;
    this.floorplanTable = undefined;
    this.note = undefined;
    this.isRoundTable = false;
    this.isActive = true;
    this.combinationTablePartIds = undefined;
  }

  isReservedForWalkIns() {
    if(this.venuePolicies && this.venuePolicies.length > 0) {
      const tableBookingPolicy = this.venuePolicies.find(p => p.policyType === POLICY_TYPE.TableBooking);
      if(tableBookingPolicy && tableBookingPolicy.limits && tableBookingPolicy.limits.length > 0) {
        const softLimit = tableBookingPolicy.limits.find(l => l.limitType === POLICY_LIMIT_TYPE.Soft);
        if(softLimit) {
          return softLimit.minPercentage === 0 && softLimit.maxPercentage === 0;
        }
      }
    }
    return false;
  }

  isCombinationTable() {
    return this.combinationTablePartIds && this.combinationTablePartIds.length > 0;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    const table =  Object.assign(new VenueTable(), json);
    if(table.venuePolicies) {
      table.venuePolicies = table.venuePolicies.map(m => {
        return PolicyConfiguration.fromJSON(m);
      });
    }

    if(table.seatingStrategies) {
      table.seatingStrategies = table.seatingStrategies.map(m => {
        return SeatingStrategyBase.fromJSON(m);
      });
    }
    return table;
  }
}


export class VENUE_TABLE_TYPE {
  static Low = 1;
  static high = 2;

  static nameof(type){
    switch(type) {
      case VENUE_TABLE_TYPE.Low: {
        return "Low table";
      }
      case VENUE_TABLE_TYPE.High: {
        return "High table";
      }
    }
  }
}

export class VenueTableAndScoreResult {
  constructor(table, score){
    this.table = table;
    this.score = score;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    let result = Object.assign(new VenueTableAndScoreResult(), json);
    result.table = VenueTable.fromJSON(result.table);
    return result;
  }
}

